import * as React from "react"
import {useEffect} from "react"

import {HOME_ROUTES, PRICING_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider } from "@tour"
import {isSystemBusy, aiInsightsProvider, resetAiInsights} from "@signals";
import {priceChangesIsEmpty, priceChangesTableData, priceChangesSubmittedFilters, resetPricingChangesSignals} from "./@signals";
import PricingChangesContent from "./Content";
import PricingChangesFilters from "./Filters";

const MAX_ROWS = 50

function getPricingChangesInsightsData() {
    const rows = priceChangesTableData.value
    const filters = priceChangesSubmittedFilters.value
    if (!rows.length) return null

    return {
        dashboard: "pricing-changes",
        data: rows.slice(0, MAX_ROWS),
        filters: {
            country: filters.country,
            retailer: filters.retailer,
            prevSingleDate: filters.prevSingleDate,
            currentSingleDate: filters.currentSingleDate
        }
    }
}


export default function PricingChangesPage() {

    useEffect(() => {
        aiInsightsProvider.value = getPricingChangesInsightsData
        return () => {
            aiInsightsProvider.value = null
            resetAiInsights()
            resetPricingChangesSignals()
        }
    }, []);

    return <PageWrapper
        actions={null}
        tourPageKey="pricingChanges"
        head={`DIP Insight | ${PRICING_ROUTES.CHANGES_TITLE}`}
        title={PRICING_ROUTES.CHANGES_TITLE}
        subtitle={PRICING_ROUTES.CHANGES_SUBTITLE}
        filters={<PricingChangesFilters />}
        hasErrors={isSystemBusy.value}
    >
        <PricingChangesContent />
    </PageWrapper>
}
